import isEmpty from 'lodash/isEmpty'
import { useState, useEffect } from 'react'
import Viewer from 'react-viewer';
import ImagePlaceHolder from '../../assets/img/placeholder.jpg'

const ImagePreview = ({ imageList = [], ObjectKey }) => {
  const [ visible, setVisible ] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  useEffect(() => {
    if (!isEmpty(imageList)) {
      const images = imageList.map((image) => {
        return {src: image[ObjectKey]}
      })
      setSelectedImages(images);
    }
  }, [imageList])

  return (
    <>
      <div className="flex">
        <div className="flex flex-col">
          {imageList?.map((image, index) => (
            <div
              key={`${ObjectKey}-${index}`}
              className={`cursor-pointer p-2 w-20 mb-5 border-2  rounded-lg h-20 ${
                selectedImageIndex === index 
                  ? 'border-blue-300'
                  : 'border-gray-200'
              }`}
              onClick={() => setSelectedImageIndex(index)}
            >
              <img
                src={image[ObjectKey]}
                alt="prescription_image"
                className={`object-fit w-full h-full `}
              />
            </div>
          ))}
        </div>
        <div className="w-4" />
        <div className="p-2 border-2 border-gray-300 rounded-lg h-96 w-96">
          <img
            src={imageList[selectedImageIndex]?.[ObjectKey]}
            alt="prescription_image"
            className="object-contain w-full h-full zoom"
            onClick={() => setVisible(true)}
          />
        </div>
      </div>
        <Viewer
          visible={visible}
          onClose={() => { setVisible(false); } }
          activeIndex={selectedImageIndex}
          images={selectedImages}
          defaultImg={ImagePlaceHolder}
        />
    </>
  )
}

export default ImagePreview
